<template>
  <div class="page">
    <div class="searchView">
      <div class="tabLine">
        <div
          class="tabItem"
          :class="[activeIndex == '1' ? 'active' : '']"
          @click="handleSelect('1')"
        >
          资产列表
        </div>
        <div
          class="tabItem"
          :class="[activeIndex == '2' ? 'active' : '']"
          @click="handleSelect('2')"
        >
          调拨列表
        </div>
        <div
          class="tabItem"
          :class="[activeIndex == '3' ? 'active' : '']"
          @click="handleSelect('3')"
        >
          调拨验收
        </div>
      </div>
    </div>
    <div class="content" v-show="activeIndex === '1'">
      <el-form class="searchBox">
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input
                style="width: 180px; margin-right: 10px"
                placeholder="资产名称/编号/规格"
                v-model="search1.keyword"
                clearable
                @keyup.enter.native="changeSearch1"
                size="small"
              ></el-input>
              <el-button @click="changeSearch1" type="warning" size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="分类" :label-width="'60px'">
              <el-select
                style="width: 100px"
                class="select"
                v-model="curType"
                @change="changeSearch1"
                filterable
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <resetBtn
              @reset="reset1"
              style="width: 56px; display: inline-block; margin: 0px 30px"
            ></resetBtn>
          </el-col>
          <el-col :span="8" :offset="5">
            <!-- transfersList -->
            <el-button
              size="mini"
              @click="$router.push({ path: '/wuliao/transfersList' })"
              >资产调拨</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData1" style="width: 100%">
        <el-table-column prop="no" label="分类" column-key="tab1key1">
          <template slot-scope="scope">
            {{ scope.row.assetsType && scope.row.assetsType.name }}
          </template>
        </el-table-column>
        <el-table-column label="编号" column-key="tab1key2">
          <template slot-scope="scope">
            {{ scope.row.assetsCode }}
          </template>
        </el-table-column>
        <el-table-column label="名称" column-key="tab1key3">
          <template slot-scope="scope">
            <span>{{ scope.row.assetsName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="规格" column-key="tab1key4">
          <template slot-scope="scope">
            <span>{{ scope.row.skuName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="库存" column-key="tab1key8">
          <template slot-scope="scope">
            {{
              scope.row.stockInfo.already +
              scope.row.stockInfo.wait +
              scope.row.stockInfo.lock
            }}
            (未分配{{ scope.row.stockInfo.wait }},调拨中{{
              scope.row.stockInfo.lock
            }})
          </template>
        </el-table-column>
        <el-table-column label="操作" column-key="tab1key9">
          <template slot-scope="scope">
            <el-button
              @click="
                $router.push({
                  path: '/wuliao/AssetList',
                  query: { info: scope.row },
                })
              "
              type="text"
              size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <page
        :total="page1.total"
        :page="page1.page"
        @change="changePage1"
        style="padding: 10px 0"
      ></page>
    </div>

    <div class="content" v-show="activeIndex === '2'">
      <el-form class="searchBox">
        <el-row>
          <el-col :span="5">
            <el-form-item>
              <el-input
                style="width: 180px; margin-right: 10px"
                placeholder="资产名称/编号"
                v-model="search2.keyword"
                clearable
                @keyup.enter.native="changeSearch2"
                size="small"
              ></el-input>
              <el-button @click="changeSearch2" type="warning" size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态" :label-width="'60px'">
              <el-select
                style="width: 100px"
                class="select"
                v-model="search2.state"
                @change="changeSearch2"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '正常', value: '1' },
                    { label: '取消', value: '2' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="调拨门店" :label-width="'60px'">
              <el-select
                v-model="storeId2"
                placeholder="请选择"
                class="titleSelect"
                size="small"
                @change="changeSearch2"
              >
                <el-option
                  v-for="item in storeList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="调拨时间" :label-width="'90px'">
              <el-date-picker
                @change="changeSearch2"
                v-model="datetimerange2"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 220px"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <resetBtn
              @reset="reset2"
              style="width: 56px; display: inline-block; margin: 0px 30px"
            ></resetBtn>
          </el-col>
          <el-col :span="2">
            <el-button
              size="mini"
              @click="$router.push({ path: '/wuliao/transfersList' })"
              >资产调拨</el-button
            >
          </el-col>
        </el-row>
      </el-form>

      <!-- 查看 -->
      <el-dialog title="调拨单查看" :visible.sync="dialogFormVisible">
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <span>调拨单号:&nbsp;{{ tabInfo && tabInfo.processNumber }}</span>
          <span
            >出库时间:&nbsp;{{
              tabInfo && tabInfo.createOperationInfo.operationTime
            }}</span
          >
          <span
            >发起人:&nbsp;{{
              tabInfo && tabInfo.createOperationInfo.userName
            }}</span
          >
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <span>调拨备注:&nbsp;{{ tabInfo && tabInfo.remark }}</span>
          <span>状态:&nbsp;{{ tabInfo && tabInfo.state.name }}</span>
          <span>调拨门店:&nbsp;{{ tabInfo && tabInfo.receiveInfo.name }}</span>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <!-- <span v-show="tabInfo.updateOperationInfo">验收时间:&nbsp;{{tabInfo.updateOperationInfo?tabInfo.updateOperationInfo.operationTime:''}}</span> -->
          <!-- <span v-show="tabInfo.updateOperationInfo">验收人:&nbsp;{{tabInfo.updateOperationInfo?tabInfo.updateOperationInfo.userName:''}}</span> -->
          <span>验收备注:&nbsp;{{ tabInfo && tabInfo.remark }}</span>
        </div>
        <el-table :data="outInboundDetailsList" style="width: 100%">
          <el-table-column label="编号">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="名称">
            <template slot-scope="scope">
              <span>{{ scope.row.assetsName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.skuName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="调拨数量">
            <template slot-scope="scope">
              {{ scope.row.count }}
            </template>
          </el-table-column>
        </el-table>
        <!-- <div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
				</div> -->
      </el-dialog>

      <el-table :data="tableData2" style="width: 100%">
        <el-table-column
          prop="processNumber"
          label="编号"
          column-key="tab2key1"
        >
          <template slot-scope="scope">
            {{ scope.row.processNumber || "" }}
          </template>
        </el-table-column>
        <el-table-column label="调拨门店" column-key="tab2key2">
          <template slot-scope="scope">
            {{ scope.row.receiveInfo.name }}
          </template>
        </el-table-column>
        <el-table-column label="调拨时间" column-key="tab2key3">
          <template slot-scope="scope">
            <span>{{
              scope.row.createOperationInfo &&
              scope.row.createOperationInfo.operationTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发起人" column-key="tab2key4">
          <template slot-scope="scope">
            <span>{{ scope.row.createOperationInfo.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" column-key="tab2key5">
          <template slot-scope="scope">
            {{ scope.row.state.name }}
          </template>
        </el-table-column>
        <el-table-column label="调拨备注" column-key="tab2key6">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" column-key="tab2key7">
          <template slot-scope="scope">
            <el-button @click="see(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <page
        :total="page2.total"
        :page="page2.page"
        @change="changePage2"
        style="padding: 10px 0"
      ></page>
    </div>

    <div class="content" v-show="activeIndex === '3'">
      <el-form class="searchBox">
        <el-row>
          <el-col :span="5">
            <el-form-item>
              <el-input
                style="width: 180px; margin-right: 10px"
                placeholder="资产名称/编号/规格"
                v-model="search3.keyword"
                clearable
                @keyup.enter.native="changeSearch3"
                size="small"
              ></el-input>
              <el-button @click="changeSearch3" type="warning" size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态" :label-width="'60px'">
              <el-select
                style="width: 100px"
                class="select"
                v-model="search3.state"
                @change="changeSearch3"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '正常', value: '1' },
                    { label: '取消', value: '2' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="来源门店" :label-width="'60px'">
              <el-select
                v-model="storeId"
                placeholder="请选择"
                class="titleSelect"
                size="small"
                @change="changeSearch3"
              >
                <el-option
                  v-for="item in storeList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="调拨时间" :label-width="'90px'">
              <el-date-picker
                @change="changeSearch3"
                v-model="datetimerange3"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 220px"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <resetBtn
              @reset="reset3"
              style="width: 56px; display: inline-block; margin: 0px 30px"
            ></resetBtn>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableData3" style="width: 100%">
        <el-table-column
          prop="processNumber"
          label="编号"
          column-key="tab3key1"
        >
          <template slot-scope="scope">
            {{ scope.row.processNumber || "" }}
          </template>
        </el-table-column>
        <el-table-column label="来源门店" column-key="tab3key2">
          <template slot-scope="scope">
            {{ scope.row.receiveInfo && scope.row.receiveInfo.name }}
          </template>
        </el-table-column>
        <el-table-column label="调拨时间" column-key="tab3key3">
          <template slot-scope="scope">
            <span>{{
              scope.row.createOperationInfo &&
              scope.row.createOperationInfo.operationTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="调拨备注" column-key="tab3key4">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" column-key="tab3key5">
          <template slot-scope="scope">
            {{ scope.row.state.name }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="验收日期" column-key="tab3key6">
          <template slot-scope="scope">
						<span>{{scope.row.updateOperationInfo.operationTime}}</span>
					</template>
        </el-table-column> -->
        <el-table-column label="操作" column-key="tab3key7">
          <template slot-scope="scope">
            <el-button
              @click="
                $router.push({
                  path: '/wuliao/inspectionList',
                  query: { id: scope.row.processNumber },
                })
              "
              type="text"
              size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <page
        :total="page3.total"
        :page="page3.page"
        @change="changePage3"
        style="padding: 10px 0"
      ></page>
    </div>
  </div>
</template>
<script>
import page from "../../../components/page.vue";
import resetBtn from "../../../components/resetBtn.vue";
export default {
  components: {
    page,
    resetBtn,
  },
  data() {
    return {
      dialogFormVisible: false,
      activeIndex: "1",
      // 资产列表
      search1: {
        keyword: "",
        typeId: "",
      },
      page1: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData1: [],
      // 调拨列表
      search2: {
        keyword: "",
        state: "",
        shopId: "",
      },
      page2: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData2: [],
      shopsList: [],
      outInboundDetailsList: [],
      datetimerange2: [],
      // 调拨验收
      search3: {
        keyword: "",
        state: "",
        shopId: "",
      },
      tabInfo: null,
      page3: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData3: [],
      shopsList1: [],
      datetimerange3: [],
      formLabelWidth: "500px",
      tableData: [], //调拨单查看
      storeList: [], //门店信息
      storeId: "",
      storeId2: "",
      curType: "",
      typeList: [
        { id: "1", name: "办公" },
        { id: "2", name: "器械" },
        { id: "3", name: "用品" },
        { id: "4", name: "其它" },
      ],
    };
  },
  mounted() {
    this.getTableData1();
    this.getTableData2();
    this.getTableData3();
    this.getStoreData();
  },
  methods: {
    //获取门店
    getStoreData() {
      let params = {
        companyId: "5e9412e0b2bfbc030160bdd5",
      };
      this.$http
        .get(process.env.VUE_APP_Url2 + "api/CompanyInfo/shoplist", params)
        .then((res) => {
          if (res.code == 0) {
            // console.log('门店', res)
            this.storeList = res.data;
          }
        });
    },
    // 资产列表
    reset1() {
      this.page1.page = 1;
      this.search1.keyword = "";
      this.curType = "";
      this.getTableData1();
    },
    changeSearch1() {
      this.page1.page = 1;
      this.getTableData1();
    },
    changePage1(num) {
      this.page1.page = num;
      this.getTableData1();
    },
    getTableData1() {
      let loading = this.$loading();
      let params = {
        shopId: this.$store.state.shopId, //门店id
        keyWord: this.search1.keyword,
        typeId: this.curType, // 资产类型
        pageIndex: this.page1.page,
        pageSize: this.page1.pageSize,
        processType: 1, // 调拨出库
      };
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/AssetsShop/list", params)
        .then((res) => {
          loading.close();
          console.log("资产列表", res);
          if (res.code == 0) {
            this.tableData1 = res.data.list;
            this.page1.total = res.data.count;
          }
        });
    },
    // 调拨列表
    reset2() {
      this.page2.page = 1;
      this.storeId2 = "";
      this.search2.state = "";
      this.datetimerange2 = [];
      this.getTableData2();
    },
    changeSearch2() {
      this.page2.page = 1;
      this.getTableData2();
    },
    changePage2(num) {
      this.page2.page = num;
      this.getTableData2();
    },
    getTableData2() {
      let loading = this.$loading();
      let params = {
        keyWord: this.search2.keyword,
        processType: 1, // 调拨出库
        state: 1,
        pageIndex: this.page2.page,
        pageSize: this.page2.pageSize,
        shopId: this.$store.state.shopId,
        // "state": this.search2.state,
        outShopId: this.$store.state.shopId,
        inShopId: this.storeId2,
      };
      if (this.datetimerange2 && this.datetimerange2.length == 2) {
        params.beginTime = new Date(this.datetimerange2[0]);
        params.endTime = new Date(this.datetimerange2[1]);
      }
      console.log(params);
      this.$http
        .post(process.env.VUE_APP_zichan + "/api/AssetsHandover/list", params)
        .then((res) => {
          loading.close();
          console.log("调拨列表", res);
          if (res.code == 0) {
            this.tableData2 = res.data.list;
            this.page2.total = res.data.count;
          }
        });
    },
    // 调拨单查看
    see(row) {
      this.dialogFormVisible = true;
      console.log(row);
      this.tabInfo = row;
      this.outInboundDetailsList = row.assetsInfo;
    },
    // 调拨验收
    reset3() {
      this.page3.page = 1;
      this.search3.keyword = "";
      this.search3.state = "";
      this.storeId = "";
      this.datetimerange3 = [];
      this.getTableData3();
    },
    changeSearch3() {
      this.page3.page = 1;
      this.getTableData3();
    },
    changePage3(num) {
      this.page3.page = num;
      this.getTableData3();
    },
    getTableData3() {
      let loading = this.$loading();
      let params = {
        keyWord: this.search3.keyword,
        type: 4, // 调拨入库
        processType: 1, // 调拨入库
        state: 1,
        pageIndex: this.page3.page,
        pageSize: this.page3.pageSize,
        shopId: this.$store.state.shopId,
      };
      if (this.datetimerange3 && this.datetimerange3.length == 2) {
        params.beginTime = new Date(this.datetimerange3[0]);
        params.endTime = new Date(this.datetimerange3[1]);
      }
      console.log(params);
      this.$http
        .post(process.env.VUE_APP_zichan + "/api/AssetsHandover/list", params)
        .then((res) => {
          loading.close();
          console.log("调拨验收", res);
          if (res.code == 0) {
            this.tableData3 = res.data.list;
            this.page3.total = res.data.count;
          }
        });
    },
    //tab切换
    handleSelect(str) {
      if (this.activeIndex === str) return;
      this.activeIndex = str;
      this["getTableData" + str]();
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  height: 100%;

  .searchView {
    .tabLine {
      display: flex;

      .tabItem {
        width: 88px;
        box-sizing: border-box;
        line-height: 36px;
        text-align: center;
        border-right: 1px solid #f2f2f2;
        cursor: pointer;
        font-size: 14px;
        background-color: #fff;

        &.active {
          color: $mainColor;
        }
      }
    }

    .searchBox {
      border-top: 1px solid #f2f2f2;
    }
  }

  .content {
    padding: 0 0px;
    height: calc(100% - 36px);

    ::v-deep .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        padding-right: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>
